import { Box } from "@mui/material"
import { RegimeImagePlaceholder } from "./regime-image-placeholder"

export function RegimeRowThumbnail({ item, size = 40 }) {
    const image = item.$?.images?.filter(Boolean)?.[0]

    if (!image) {
        return <RegimeImagePlaceholder size={size} iconSize={20} sx={{ borderRadius: 1, flexShrink: 0 }} />
    }

    return (
        <Box
            component="img"
            data-cy="regime-row-thumbnail"
            src={image}
            srcSet={image}
            alt="Facility"
            loading="lazy"
            sx={{ width: size, height: size, borderRadius: 1, objectFit: "cover", flexShrink: 0 }}
        />
    )
}
